import styled from "styled-components";

export const WorkSpace = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  margin-bottom: 16px;
`;

export const Empty = styled.div`
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
`;
